import { Box, Typography } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import useWorkOrders from "hooks/workOrders/useWorkOrders";
import type { WorkOrderFormSubmitPayload } from "types/workOrder";
import WorkOrderForm from "./WorkOrderForm";

export default function WorkOrderEdit() {
  const { workOrder, updateWorkOrder } = useWorkOrders();

  if (!workOrder) {
    return null;
  }

  return (
    <Box>
      <Breadcrumbs
        data={[
          { label: "Home", to: "/" },
          { label: "Work Orders", to: "/work_orders" },
          { label: `Edit ${workOrder.orderNumber ?? workOrder.order_number ?? ""}` },
        ]}
      />
      <Typography variant="h5" fontWeight="bold" sx={{ mt: 2 }}>
        Edit Work Order {workOrder.orderNumber ?? workOrder.order_number}
      </Typography>
      <WorkOrderForm
        initialValues={workOrder}
        onSubmit={async (values: WorkOrderFormSubmitPayload) => {
          await updateWorkOrder({
            uuid: workOrder.uuid,
            ...values,
          });
        }}
      />
    </Box>
  );
}
